module.exports = __webpack_public_path__ + "static/img/anxun44.e697ee8b.png";